import * as React from 'react'
import { Router, Route, Switch } from 'react-router'
import { History, LocationListener, UnregisterCallback } from 'history'

import { GlobalStyle, color } from './theme'
import { Helmet } from 'react-helmet-async'
import LoginPage from './screens/LoginPage/LoginPage'
import DashboardPage from './screens/DashboardPage/DashboardPage'
import { USER_STORE } from './stores'
import { API } from './services/api'
import { inject, observer } from 'mobx-react'
import { UserStore } from './stores/UserModel'
import RegistryPage from './screens/RegistryPage/RegistryPage'
import { FullScreenLoader } from './components/FullScreenLoader'
import { DeleteAccountRequest, DeleteAccountConfirm } from './screens/DeleteAccount'
import { DELETE_ACCOUNT_CONFIRM_PATH, DELETE_ACCOUNT_PATH, isPublicPath } from './utils/publicPaths'

interface AppProps {
  history: History
  [USER_STORE]?: UserStore
}

interface AppState {
  loaded: boolean
}

@inject(USER_STORE)
@observer
class App extends React.Component<AppProps, AppState> {
  navigationListener: UnregisterCallback = null
  private API = API.getInstance()
  state = {
    loaded: false,
  }

  componentDidMount() {
    this.navigationListener = this.props.history.listen(this.onLocationChange)
    this.authorize()
  }

  navigateToDashboard = () => this.props.history.replace('/')
  navigateToLoginPage = () => this.props.history.replace('/login') // TODO: create start page

  authorize = async (): Promise<void> => {
    const { history, [USER_STORE]: userStore } = this.props

    // Interceptor handles token refresh automatically for all requests
    const response = await this.API.getCurrentUser()
    
    if (response.ok) {
      userStore.setUserData(response.data)
      const { pathname } = history.location
      if (pathname.includes('login') || pathname.includes('register')) {
        this.navigateToDashboard()
      }
    } else if (!isPublicPath(history.location.pathname)) {
      // API interceptor handles cookie cleanup on 401, just navigate
      this.navigateToLoginPage()
    }
    this.setState({ loaded: true })
  }

  handleContentScroll = () => {
    // TODO: Check if needed
    // window.scrollTo(0, 0)
  }

  onLocationChange: LocationListener = () => {
    // TODO:
    this.handleContentScroll()
  }

  componentWillUnmount() {
    this.navigationListener()
  }

  render() {
    const { history } = this.props
    const { loaded } = this.state
    return (
      <>
        <GlobalStyle />
        <Helmet>
          <meta name="theme-color" content={color.background} />
        </Helmet>
        <Router history={history}>
          {loaded ? (
            <Switch>
              <Route path="/login" component={LoginPage} />
              <Route path="/registry" component={RegistryPage} />
              <Route path={DELETE_ACCOUNT_CONFIRM_PATH} component={DeleteAccountConfirm} />
              <Route path={DELETE_ACCOUNT_PATH} component={DeleteAccountRequest} />
              <Route path="/" component={DashboardPage} />
            </Switch>
          ) : (
            <FullScreenLoader />
          )}
        </Router>
      </>
    )
  }
}

export default App
